module.exports = __webpack_public_path__ + "static/media/MercyMinistry.d86cae69.jpg";